import React from 'react';
import {Card, CardContent, useMediaQuery, useTheme} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import { ListSkeleton } from 'common/ui/skeleton-ui';
import SectionTab from 'constants/SectionTab';
import { ItemList } from 'modules2/components';
import container from "./GenresCard.container";

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 345,
        background: theme.palette.paperColor,
        color: theme.palette.textColor,
    },
    listContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        marginTop: 10,
        marginBottom: 10,
    },
    empty: {
        fontFamily: theme.typography.fontFamily,
        paddingBottom: theme.spacing(1),
    },
    label: {
        color: theme.palette.darkGray,
        fontFamily: 'Arial',
        '&$focusedLabel': {
            color: theme.palette.darkGray,
        },
        '&$erroredLabel': {
            color: '#f44336',
        },
    },
    focusedLabel: {},
    erroredLabel: {},
    inputBase: {
        color: theme.palette.alternateTextColor,
        fontFamily: 'Arial',
    },
    underline: {
        '&$error:after': {
            borderBottomColor: '#f44336',
        },
        '&:after': {
            borderBottom: `2px solid rgb(255, 0, 102)`,
        },
    },
    error: {},
}));

const GenresCard = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));
    const {
        podcastState: { loading, genres },
        onSetCurrentTab,
        onSetGenres,
        onRequestGenresPodcast,
    } = props;

    const onListItemClick = (tab, genresId) => {
        onSetCurrentTab(tab);
        onSetGenres(genresId);
        onRequestGenresPodcast(genresId, 1);
        /*const genreName = genres.filter((e) => e.id === genresId).map((genre) => genre.name);
        if (genreName) {
            onSetGenres(genreName[0]);
            onRequestGenresPodcast(genresId, 1);
        }*/
    };

    return(
        <Card className={classes.root}>
            <CardContent style={{ padding: 0 }}>
                <div className={classes.listContainer}>
                    {loading && genres.length === 0 &&
                    [...Array(matchesXS ? 5 : 6)].map((_, idx) => {
                        return <ListSkeleton key={idx} />;
                    })
                    }
                    {!loading && genres.length === 0 ?
                        (
                            <div className={classes.empty}>
                                Genres not available.
                            </div>
                        ) :
                        (
                            genres.sort((a, b) => (a.name > b.name) ? 1 : -1)
                                .map((value, index) => {
                                    return(
                                        <ItemList
                                            key={index}
                                            id={value.id}
                                            name={value.name}
                                            sectionTab={SectionTab.GenreStation}
                                            onListItemClick={onListItemClick}
                                        />
                                    );
                                })
                        )
                    }
                </div>
            </CardContent>
        </Card>
    );
};

export default container(GenresCard);